/**
 * Challenges Page Styles
 * Composed from sub-files via the combine pattern.
 */

import { StyleSheet } from 'react-native'
import type { Theme } from '../../theme/getTheme'
import { getChallengesLayoutStyleSheet } from './_challengesLayout.styles'
import { getChallengesEmptyStateStyleSheet } from './_challengesEmptyState.styles'
import { getChallengesSectionsStyleSheet } from './_challengesSections.styles'
import { getChallengesMenuStyleSheet } from './_challengesMenu.styles'

export const getChallengesPageStyles = (theme: Theme) => {
  const combined = {
    ...getChallengesLayoutStyleSheet(theme),
    ...getChallengesEmptyStateStyleSheet(theme),
    ...getChallengesSectionsStyleSheet(theme),
    ...getChallengesMenuStyleSheet(theme),
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return StyleSheet.create(combined as any)
}

// Export default styles for backward compatibility (uses light theme)
// Components should use useTheme() hook and getChallengesPageStyles(theme)
import { getTheme } from '../../theme/getTheme'
export const challengesPageStyles = getChallengesPageStyles(getTheme('light'))
